import React from "react";
import { useTranslation } from "react-i18next";

export default function PaymentChecks({
  title,
  items = [],
  bordered = true,
  marginTop = 10,
}) {
  const { t } = useTranslation();
  const resolvedTitle = title || t("paymentChecks.title");
  if (!items || !items.length) return null;

  const boxStyle = bordered
    ? {
        marginTop,
        padding: 10,
        borderRadius: 14,
        background: "rgba(0,0,0,0.18)",
        border: "1px solid rgba(34,197,94,0.25)",
        width: "100%",
        boxSizing: "border-box",
      }
    : { marginTop };

  return (
    <div style={boxStyle}>
      <div style={{ fontSize: 13, opacity: 0.8, marginBottom: 6 }}>{resolvedTitle}</div>

      {items.map((tItem, idx) => (
        <div key={idx} style={{ display: "flex", gap: 10, alignItems: "flex-start", marginTop: 4 }}>
          <span style={{ color: "#22c55e", fontWeight: 900, lineHeight: "18px" }}>✓</span>
          <span style={{ fontSize: 14, color: "rgba(255,255,255,0.92)", lineHeight: 1.25 }}>
            {tItem}
          </span>
        </div>
      ))}
    </div>
  );
}
